var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4, _rect5, _g, _rect6, _g2, _rect7, _path5, _path6, _path7, _path8, _rect8, _path9, _rect9, _path10, _rect10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChooseCryptoWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 168,
    viewBox: "0 0 250 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 49.5929,
    width: 35,
    height: 35,
    rx: 6,
    transform: "rotate(-20 6 49.5929)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8797 49.4903C34.1679 49.3854 34.4827 49.4047 34.7565 49.5321C35.0321 49.6646 35.2456 49.9011 35.3432 50.1856C36.407 53.267 37.1413 55.6535 37.5958 57.589C38.0556 59.5227 38.2331 61.0177 38.1509 62.3105C38.0932 63.1754 37.9108 63.9401 37.6239 64.6381C37.2342 65.5657 36.6827 66.3368 36.0552 67.1064C35.787 67.4361 35.5041 67.7682 35.2074 68.1166C34.5752 68.8597 33.8788 69.6771 33.1272 70.7037C32.8559 71.0759 32.3877 71.2463 31.9406 71.1355C30.6866 70.8302 29.6142 70.6496 28.6431 70.486C28.4279 70.4493 28.2169 70.4138 28.0098 70.378C26.8708 70.1757 25.8345 69.965 24.8214 69.4841C24.1485 69.1703 23.503 68.7243 22.9037 68.1335C22.0936 67.3459 21.3586 66.304 20.5832 64.8927C19.5475 63.0058 18.4414 60.4461 17.0646 56.8385C16.9566 56.5578 16.9629 56.2412 17.0889 55.9626C17.2159 55.6894 17.4506 55.47 17.7389 55.3651L18.1803 55.2045C19.5445 54.7138 22.5017 53.4861 24.3648 50.5151C24.6423 50.0765 25.1815 49.8802 25.676 50.0378C29.0129 51.1162 32.0675 50.1558 33.4331 49.6529L33.8797 49.4903ZM35.8612 62.3699C35.9446 61.5596 35.8765 60.5078 35.5892 59.0643C35.2463 57.3384 34.5924 55.0623 33.5653 52.0142C31.9446 52.5516 29.0784 53.2457 25.8081 52.434C23.8237 55.1524 21.1819 56.4632 19.6021 57.0964C20.5682 59.5731 21.3877 61.4747 22.1233 62.9354C22.9615 64.5974 23.6823 65.6678 24.3487 66.3622C24.7903 66.8242 25.2009 67.1228 25.6475 67.356C26.2435 67.6687 26.9239 67.8576 27.8195 68.032C28.1908 68.104 28.5958 68.1721 29.0373 68.2459C29.8233 68.3776 30.7231 68.5284 31.7486 68.7553C32.3768 67.9363 32.9603 67.2505 33.4709 66.65C33.6247 66.469 33.7723 66.2956 33.9124 66.1287C34.628 65.2804 35.139 64.6056 35.4543 63.9205C35.663 63.4546 35.7983 62.9806 35.8612 62.3699Z",
    fill: "#3375BB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57.6831,
    y: 30.7817,
    width: 35,
    height: 35,
    rx: 6,
    transform: "rotate(-20 57.6831 30.7817)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.356 32.2049L74.5944 33.938C74.4353 33.9959 74.3545 34.1708 74.4092 34.3317C75.9464 38.8544 75.1571 43.9652 72.2284 48.4477C72.1354 48.59 72.1717 48.7805 72.3124 48.8761L76.5054 51.728C76.648 51.825 76.8435 51.7875 76.9383 51.6436C78.7741 48.8531 79.9764 45.8552 80.5229 42.8186C82.8933 44.7935 85.7415 46.3171 88.9415 47.2748C89.1065 47.3242 89.2804 47.2272 89.3274 47.0611L90.7063 42.1812C90.7525 42.0177 90.6578 41.8484 90.4953 41.7991C85.3703 40.2479 81.4805 36.8401 79.7511 32.3874C79.6895 32.229 79.5151 32.147 79.356 32.2049Z",
    fill: "#FF875B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 109.366,
    y: 11.9707,
    width: 35,
    height: 35,
    rx: 6,
    transform: "rotate(-20 109.366 11.9707)",
    fill: "#3B99FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.656 20.5692C125.971 15.605 131.872 13.4573 136.836 15.7721L137.433 16.0507C137.682 16.1665 137.789 16.4615 137.673 16.7097L136.72 18.7535C136.662 18.8776 136.515 18.9313 136.391 18.8734L135.568 18.49C132.105 16.8751 127.989 18.3734 126.374 21.8366L125.963 22.7171C125.905 22.8412 125.758 22.8949 125.634 22.837L123.59 21.884C123.342 21.7682 123.234 21.4732 123.35 21.225L123.656 20.5692ZM141.063 17.7431L142.882 18.5913C143.13 18.707 143.237 19.002 143.121 19.2503L139.297 27.4521C139.181 27.7004 138.886 27.8077 138.638 27.692C138.638 27.692 138.638 27.692 138.638 27.692L132.817 24.9776C132.755 24.9486 132.681 24.9755 132.652 25.0375C132.652 25.0375 132.652 25.0375 132.652 25.0375L129.938 30.8586C129.822 31.1068 129.527 31.2142 129.279 31.0985C129.279 31.0985 129.279 31.0985 129.279 31.0985L121.077 27.2738C120.828 27.1581 120.721 26.863 120.837 26.6148L121.685 24.7959C121.801 24.5476 122.096 24.4403 122.344 24.556L128.165 27.2705C128.227 27.2994 128.301 27.2726 128.33 27.2105C128.33 27.2105 128.33 27.2105 128.33 27.2105L131.044 21.3894C131.16 21.1412 131.455 21.0338 131.703 21.1495C131.703 21.1495 131.703 21.1495 131.703 21.1495L137.524 23.864C137.586 23.8929 137.66 23.8661 137.689 23.804L140.404 17.9829C140.519 17.7347 140.814 17.6273 141.063 17.7431Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3909,
    y: 91.879,
    width: 35,
    height: 35,
    rx: 6,
    transform: "rotate(-20 21.3909 91.879)",
    fill: "#2C5FF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0106 113.85C54.3681 111.536 57.646 104.506 55.3321 98.1486C53.0182 91.7911 45.9886 88.5132 39.6311 90.8271C33.2736 93.141 29.9957 100.171 32.3096 106.528C34.6236 112.886 41.6531 116.164 48.0106 113.85ZM39.3988 99.6911C39.0096 99.8328 38.8089 100.263 38.9505 100.652L41.1737 106.76C41.3153 107.15 41.7457 107.35 42.1349 107.209L48.2429 104.986C48.6322 104.844 48.8329 104.413 48.6912 104.024L46.4681 97.9163C46.3264 97.527 45.896 97.3263 45.5068 97.468L39.3988 99.6911Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.074,
    y: 73.0679,
    width: 35,
    height: 35,
    rx: 6,
    transform: "rotate(-20 73.074 73.0679)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.703 66.4339L95.2085 77.8011L95.4698 72.6089L102.703 66.4339Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9913 75.0643L91.983 79.0569L88.512 75.1413L78.9913 75.0643Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.444 85.4623L104.234 90.6492L110.673 90.1292L110.278 83.8081L105.444 85.4623Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3774 93.2351L88.1275 98.3351L93.3945 94.5943L89.1335 91.3988L84.3774 93.2351Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9612 83.4418L88.2282 86.5026L94.134 84.6454L91.6544 78.4751L88.9612 83.4418Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.451 79.26L95.1173 77.1329L97.2825 83.4995L102.99 81.1298L100.451 79.26Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3945 94.5943L96.2638 91.621L92.3928 90.3645L93.3945 94.5943Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.114 90.2196L104.234 90.6492L102.272 86.7688L100.114 90.2196Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.234 90.6492L100.114 90.2196L101.223 92.3996L101.542 93.3709L104.234 90.6492Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3945 94.5943L97.2061 94.9489L96.836 93.9964L96.2638 91.621L93.3945 94.5943Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6727 87.8278L91.4498 88.0306L93.1621 86.3435L94.6727 87.8278Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8949 86.2911L99.0979 84.183L101.504 84.371L98.8949 86.2911Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3945 94.5943L92.3646 90.2228L89.1673 91.4917L93.3945 94.5943Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.213 86.6383L104.234 90.6491L105.478 85.5552L102.213 86.6383Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.99 81.1297L97.2825 83.4994L98.9052 86.2874L99.1082 84.1793L101.515 84.3673L102.99 81.1297Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4498 88.0306L93.1725 86.3398L94.6727 87.8279L94.134 84.6454L88.2282 86.5027L91.4498 88.0306Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2282 86.5027L92.3928 90.3646L91.4498 88.0306L88.2282 86.5027Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.515 84.3673L102.272 86.7689L102.99 81.1298L101.515 84.3673Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.134 84.6455L94.6727 87.828L96.6353 91.1001L95.1031 86.4087L94.134 84.6455Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2825 83.4995L97.6801 85.4591L99.4948 90.0594L98.9052 86.2875L97.2825 83.4995Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9052 86.2873L99.4948 90.0592L100.114 90.2195L102.272 86.7688L101.515 84.3672L98.9052 86.2873Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4498 88.0306L92.3928 90.3646L96.2638 91.6211L96.6353 91.1001L94.6727 87.8279L91.4498 88.0306Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.542 93.3709L101.223 92.3996L100.883 92.2664L96.9908 93.6829L96.8361 93.9964L97.2061 94.949L93.3945 94.5944L94.8682 95.1101L97.7526 95.8723L101.706 94.4333L103.436 91.9916L104.234 90.6492L101.542 93.3709Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.114 90.2195L99.4948 90.0592L96.6353 91.1L96.2638 91.621L96.836 93.9963L96.9908 93.6828L100.883 92.2663L101.223 92.3995L100.114 90.2195Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.094 74.4003L105.438 69.8691L102.703 66.4338L95.4552 77.419L100.451 79.2599L106.425 78.8743L107.115 77.0448L106.463 76.8611L107.015 75.8069L106.195 75.5443L106.791 74.6141L106.094 74.4003Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1146 79.4502L81.525 83.3426L81.1178 83.9584L82.1729 84.2875L81.7235 85.0122L82.8237 85.4652L82.4428 86.0247L84.1371 86.9862L88.9612 83.4418L91.6047 78.8205L78.9913 75.0643L79.1146 79.4502Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.425 78.8743L100.451 79.2599L102.99 81.1297L102.272 86.7688L105.478 85.5552L110.278 83.8081L106.425 78.8743Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9612 83.4417L84.1371 86.9862L84.3774 93.2351L89.1673 91.4917L92.3928 90.3645L88.2282 86.5026L88.9612 83.4417Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2825 83.4993L95.4552 77.419L95.4801 72.6051L88.512 75.1412L91.6047 78.8204L94.134 84.6453L94.9417 86.479L96.6353 91.1L99.4948 90.0592L97.8321 85.427L97.2825 83.4993Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 124.757,
    y: 54.2568,
    width: 35,
    height: 35,
    rx: 6,
    transform: "rotate(-20 124.757 54.2568)",
    fill: "url(#paint0_linear_18_175)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18_175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.029 62.6767L135.674 62.0781C144.15 58.9929 153.523 63.3635 156.608 71.8401L157.207 73.4846L160.496 72.2875C161.404 71.957 161.872 70.9527 161.542 70.0445C157.465 58.8432 145.079 53.0678 133.878 57.1448C132.97 57.4753 132.502 58.4795 132.832 59.3877L134.029 62.6767Z",
    fill: "url(#paint1_radial_18_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.157 71.6406L161.542 70.0445C161.872 70.9527 161.404 71.957 160.496 72.2875L157.755 73.2851L157.157 71.6406Z",
    fill: "url(#paint2_linear_18_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.878 57.1448L135.474 61.53L133.83 62.1285L132.832 59.3877C132.502 58.4795 132.97 57.4753 133.878 57.1448Z",
    fill: "url(#paint3_linear_18_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.83 62.1285L135.474 61.53C144.254 58.3346 153.961 62.8613 157.157 71.6406L157.755 73.2851L152.822 75.0807L152.223 73.4362C150.02 67.3815 143.325 64.2596 137.27 66.4634L135.625 67.0619L133.83 62.1285Z",
    fill: "url(#paint4_radial_18_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.771 73.2367L157.157 71.6406L157.755 73.2851L153.37 74.8812L152.771 73.2367Z",
    fill: "url(#paint5_linear_18_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.426 66.5138L133.83 62.1285L135.474 61.53L137.07 65.9152L135.426 66.5138Z",
    fill: "url(#paint6_linear_18_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.424 69.2546C136.754 70.1628 137.758 70.6311 138.667 70.3005C142.602 68.8681 146.954 70.8973 148.386 74.8328C148.717 75.7411 149.721 76.2093 150.629 75.8788L153.37 74.8812L152.771 73.2367C150.457 66.8793 143.428 63.6013 137.07 65.9153L135.426 66.5138L136.424 69.2546Z",
    fill: "url(#paint7_radial_18_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.386 74.8329L152.771 73.2368L153.37 74.8813L150.629 75.8788C149.721 76.2094 148.717 75.7411 148.386 74.8329Z",
    fill: "url(#paint8_radial_18_175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.667 70.3005C137.758 70.6311 136.754 70.1628 136.424 69.2546L135.426 66.5138L137.07 65.9153L138.667 70.3005Z",
    fill: "url(#paint9_radial_18_175)"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36.7818,
    y: 134.165,
    width: 35,
    height: 35,
    rx: 6,
    transform: "rotate(-20 36.7818 134.165)",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7596 136.24C65.9609 135.486 64.9397 135.01 63.8483 134.883C62.6512 134.744 61.3299 135.225 58.6863 136.187C58.1508 136.382 56.8725 136.847 56.4386 137.005C56.0047 137.163 54.7244 137.629 54.1908 137.823C51.5521 138.784 50.2259 139.266 49.398 140.142C48.6434 140.941 48.1675 141.962 48.0414 143.053C47.9017 144.251 48.3827 145.572 49.3445 148.214C50.3064 150.857 50.7876 152.179 51.6643 153.007C52.4624 153.762 53.4834 154.238 54.5746 154.365C55.7717 154.503 57.094 154.022 59.7366 153.06C60.2722 152.865 61.5505 152.4 61.9844 152.242C62.4183 152.084 63.6986 151.618 64.2322 151.424C66.8709 150.464 68.197 149.981 69.0249 149.105C69.7794 148.307 70.2557 147.285 70.3825 146.194C70.5212 144.997 70.0403 143.676 69.0781 141.032C68.1159 138.388 67.6353 137.068 66.7596 136.24Z",
    fill: "#FFCEAA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7518 149.009C55.5419 148.813 55.282 148.679 55.0008 148.622C54.7195 148.564 54.4278 148.585 54.1578 148.683L52.6206 149.242C52.4635 149.3 52.3203 149.391 52.2003 149.507C52.0802 149.624 51.9861 149.765 51.9237 149.92C51.8614 150.076 51.8324 150.242 51.8385 150.41C51.8446 150.577 51.8857 150.741 51.9592 150.892C52.1924 151.368 52.4153 151.713 52.6632 151.947C53.2347 152.485 53.9636 152.825 54.7427 152.917C55.3137 152.983 56.0817 152.795 57.2298 152.407C57.3941 152.351 57.5411 152.254 57.6565 152.125C57.7719 151.995 57.8516 151.838 57.888 151.669C57.9244 151.499 57.9162 151.323 57.8641 151.158C57.812 150.993 57.7179 150.844 57.5909 150.726L55.7518 149.009Z",
    fill: "#FF3B9A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9185 147.695C53.4246 147.511 53.8789 147.207 54.2428 146.81C54.6066 146.413 54.8693 145.934 55.0088 145.413L55.7247 142.743C55.8539 142.262 55.8607 141.755 55.7444 141.27C55.6283 140.785 55.3927 140.337 55.0593 139.966L55.0547 139.954C54.8957 139.774 54.6915 139.64 54.4633 139.566C54.235 139.492 53.9911 139.48 53.7568 139.532C51.991 140.181 50.9651 140.604 50.4581 141.142C49.9183 141.712 49.5779 142.441 49.488 143.22C49.4183 143.859 49.89 145.411 50.3194 146.651C50.399 146.882 50.5239 147.095 50.6867 147.278C50.8496 147.46 51.0472 147.608 51.2679 147.713C51.4887 147.818 51.7282 147.878 51.9725 147.89C52.2167 147.901 52.4608 147.864 52.6904 147.78L52.9185 147.695Z",
    fill: "#FF3B9A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8288 137.272C65.2581 136.735 64.5298 136.397 63.7516 136.306C62.9728 136.215 61.8313 136.598 59.861 137.311C57.193 138.283 57.4806 141.654 57.2068 142.675L56.4018 145.678C56.2725 146.161 56.2766 146.669 56.4136 147.149C56.5506 147.63 56.8154 148.064 57.1797 148.405L59.3161 150.41C59.6072 150.684 59.9692 150.871 60.3611 150.949C60.753 151.028 61.1591 150.995 61.5333 150.855L61.5675 150.843C62.0063 150.683 63.3589 150.191 63.8035 150.029C66.149 149.175 67.4449 148.703 68.0365 148.078C68.574 147.507 68.9137 146.778 69.0052 145.999C69.1046 145.144 68.634 143.851 67.7792 141.503C66.9244 139.154 66.456 137.867 65.8288 137.272Z",
    fill: "#FF3B9A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 88.4649,
    y: 115.354,
    width: 35,
    height: 35,
    rx: 6,
    transform: "rotate(-20 88.4649 115.354)",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.303 117.389C114.165 114.261 110.228 112.754 106.587 114.079C102.945 115.405 100.899 119.09 102.037 122.217L102.703 124.047L99.972 125.041L104.762 138.201L115.565 138.746L123.49 131.384L118.722 118.283L115.991 119.277L115.303 117.389ZM105.419 120.987C104.882 119.511 105.883 117.81 107.704 117.148C109.525 116.485 111.385 117.145 111.922 118.62L112.588 120.449L106.085 122.816L105.419 120.987ZM118.945 130.632L114.212 135.028L107.76 134.703L104.882 126.796L116.067 122.725L118.945 130.632Z",
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 140.148,
    y: 96.5431,
    width: 35,
    height: 35,
    rx: 6,
    transform: "rotate(-20 140.148 96.5431)",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M150.935 100.598L155.034 102.61C155.872 101.169 157.09 100.009 158.55 99.2584C160.009 98.508 161.653 98.1978 163.298 98.3626C164.942 98.5273 166.521 99.1604 167.859 100.191C169.196 101.221 170.238 102.609 170.868 104.197L170.96 104.449L174.648 114.581L170.554 112.568C169.717 114.009 168.5 115.171 167.041 115.923C165.582 116.674 163.939 116.985 162.294 116.822C160.65 116.658 159.071 116.026 157.733 114.996C156.396 113.966 155.353 112.579 154.723 110.992L154.631 110.739L150.935 100.598ZM154.827 104.969L156.655 109.991C157.086 111.172 157.817 112.22 158.77 113.021C159.722 113.821 160.862 114.346 162.065 114.537C163.269 114.729 164.492 114.58 165.603 114.108C166.715 113.636 167.673 112.858 168.375 111.856L168.495 111.682L155.374 105.237L154.827 104.969ZM157.212 103.322L157.093 103.498L170.212 109.941L170.755 110.209L168.928 105.189C168.498 104.007 167.768 102.96 166.815 102.159C165.863 101.359 164.724 100.835 163.521 100.643C162.317 100.451 161.095 100.599 159.984 101.071C158.873 101.543 157.915 102.321 157.212 103.322Z",
    fill: "#23262F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 49.5929,
    width: 145,
    height: 125,
    transform: "rotate(-20 6 49.5929)",
    fill: "url(#paint10_radial_18_175)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_175",
    x1: 142.257,
    y1: 54.2568,
    x2: 142.257,
    y2: 89.2568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174299"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001E59"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_18_175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.26 77.4265) rotate(-110) scale(21.5833)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.770277,
    stopColor: "#FF4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8754C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18_175",
    x1: 157.182,
    y1: 72.5626,
    x2: 161.841,
    y2: 70.8668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8754C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18_175",
    x1: 133.056,
    y1: 57.444,
    x2: 134.752,
    y2: 62.1033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8754C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_18_175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.26 77.4265) rotate(-110) scale(16.9167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.723929,
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_18_175",
    x1: 153.071,
    y1: 74.0589,
    x2: 157.456,
    y2: 72.4628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_18_175",
    x1: 136.248,
    y1: 66.2145,
    x2: 134.652,
    y2: 61.8293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9901"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_18_175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(141.26 77.4265) rotate(-110) scale(12.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59513,
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_18_175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.411 75.7549) rotate(-20) scale(4.95833 13.2222)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_18_175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.944 70.8738) rotate(-110) scale(4.95833 94.0247)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DA40"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_18_175",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.5 112.093) rotate(90) scale(62.5 72.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F7F1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F7F1",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(73.074 73.0679) rotate(-20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18_175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(124.757 54.2568) rotate(-20)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseCryptoWallet);
export default __webpack_public_path__ + "static/media/ChooseCryptoWallet.1eb21121a090b68002814c42bb41e1d8.svg";
export { ForwardRef as ReactComponent };